export default __webpack_public_path__ + "static/media/img3.9e855058.webp";